import { createClient } from 'graphqurl';
import { getVariableOrDefault } from './utils/env';

const endpoint = getVariableOrDefault(
  'VUE_APP_THEME_SERVICE_URL',
  'https://c360-be.stg.adportal.io/graphql',
);

const query = `
  query {
    hasAccessToSubmitRequest 
  }
`;

/**
 * @param {string} token - The user's authentication token.
 * @returns {Boolean} - Access to the submit request page.
 */
export const hasAccessToSubmitRequest = async (token) => {
  try {
    const gqlClient = createClient({
      endpoint,
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    const {
      data: { hasAccessToSubmitRequest },
    } = await gqlClient.query({
      query,
    });

    return hasAccessToSubmitRequest;
  } catch (error) {
    console.error(error);
    return [];
  }
};
